import { useCallback, useState } from "react";

/**
 * Which optional table columns are shown. At least one always stays on, so a
 * table can't be emptied by unticking everything.
 */
export function useColumnVisibility<K extends string>(initial: readonly K[]) {
  const [visible, setVisible] = useState<Set<K>>(() => new Set(initial));
  const toggle = useCallback((key: K) => {
    setVisible((current) => {
      const next = new Set(current);
      if (next.has(key)) {
        if (next.size === 1) return current;
        next.delete(key);
      } else {
        next.add(key);
      }
      return next;
    });
  }, []);
  return { visible, toggle };
}
